<template>
  <div id="user">
    <section>
      <h1 class="has-text-centered has-text-weight-bold is-c-text is-cs-2">アカウント</h1>
      <div v-if="image">
        <figure class="user-circle image is-96x96">
          <cachalog-img :type="'background'" class="is-rounded" :caption="image.caption"
            :full-path="image.full_path" :source="image.source"></cachalog-img>
        </figure>
      </div>
      <div class="has-text-centered">{{ nickname }}</div>
      <div class="has-text-centered" v-if="uid === user.uid">
        <router-link :to="{name: 'account'}">
          <button class="button is-rounded is-cs-4 is-small has-text-weight-bold">編集</button>
        </router-link>
      </div>
    </section>
    <section class="page-list has-text-centered">
      <h2 class="is-cs-5">マイショップ</h2>
      <ul class="flex-list">
        <cachalog-page-list v-for="page in pages" v-if="page.publish || targetUser.uid === user.uid"
          :page="page" :key="page.id"></cachalog-page-list>
      </ul>
      <div class="has-text-centered" v-if="uid === user.uid">
        <router-link :to="{name: 'page-creator'}">
          <button class="button is-rounded is-c-primary is-cs-4 is-large" :disabled="reachedPageCreationLimit">
            ショップを新規作成
          </button>
        </router-link>
        <p v-if="reachedPageCreationLimit">これ以上ショップを作成出来ません。</p>
      </div>
      <div class="has-text-centered howto" v-if="uid === user.uid">
        <p class="is-cs-5 is-c-text">イベント時に掲示してお客様への案内をラクに！<br>ダウンロードをして印刷しよう！<br>ショップのQRコードを貼るともっと便利</p>
        <a href="/assets/docs/howto.pdf" target="_blank">
          <button class="button is-rounded is-cs-4 is-large">
            お買い物のしかた.pdf（A4サイズ）
          </button>
        </a>
      </div>
    </section>
    <c-footer></c-footer>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { mixin, indexOf } from './common.js'
import cFooter from './view/c-footer.vue'
export default {
  components: {
    'c-footer': cFooter
  },
  mixins: [mixin],
  props: ['uid'],
  computed: {
    ...Vuex.mapState({
      user: 'user',
      users: 'users'
    }),
    reachedPageCreationLimit () {
      return this.user.pages && this.user.pages.length > 99
    },
    targetUser () {
      return this.users[this.uid] || {}
    },
    nickname () {
      return this.targetUser.nickname || ''
    },
    image () {
      return (this.targetUser.images && this.targetUser.images[0])
        ? this.targetUser.images[0] : {}
    },
    pages () {
      const pages = this.targetUser.pages
      if (!pages) {
        return []
      }
      return pages.sort((a, b) => {
        const _a = a.created ? a.created.seconds : 0
        const _b = b.created ? b.created.seconds : 0
        return _a < _b ? 1 : -1
      })
    },
    pagesMember () {
      const pages = {}
      const _pages = this.user.pages && this.user.pages.length ? this.user.pages : []
      this.pages.forEach(page => {
        pages[page.id] = indexOf(_pages, 'id', page.id) !== false
      })
      return pages
    }
  },
  created () {
    if (this.user.uid && !this.user.nickname && this.uid === this.user.uid) {
      this.$router.replace({name: 'account'})
    }
    if (!this.targetUser.uid) {
      this.$store.dispatch('fetchUser', this.uid)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user.vue